import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store2'
import StyleSelectMenu from '@/components/StyleSelectMenu'
import StyleSelectBar from '@/components/StyleSelectBar'
import SelectItem from '@/components/SelectItem'
const SvgTableView = () => import(/* webpackChunkName: "svgTable" */ '@/components/SvgTableView')
const SvgTableFooter = () => import(/* webpackChunkName: "svgTable" */ '@/components/SvgTableFooter')
const SvgTable = () => import(/* webpackChunkName: "svgTable" */ '@/components/SvgTable')
// import { getQueryParams } from './api/utils'

Vue.use(VueRouter)

const prefixTitle = 'C\'estlavie'
const dynamicProps = (route) => (
  { id: route.params.id, at: parseInt(route.params.at) }
)

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL || '/',
  routes: [
    // {
    //   path: '',
    //   redirect () {
    //     if (getQueryParams()['item']) {
    //       return {path: '/view'}
    //     } else {
    //       return {path: '/select'}
    //     }
    //   }
    // },
    {
      path: '/',
      component: StyleSelectMenu,
      props: ({path}) => (
        {routeTitle: path === '/' ? '発注コード検索' : undefined }
      ),
      children: [
        {
          name: 'SelectItem',
          path: '',
          component: SelectItem,
          beforeEnter(_to, _from, next) {
            store.commit('CLEAR_ITEM')
            document.title = prefixTitle
            next()
          }
        },
        {
          name: 'StyleSelect',
          path: ':prefix(C):itemId(\\d{4})',
          component: StyleSelectBar,
          beforeEnter(to, _from, next) {
            store.commit('SET_ITEM', to.params)
            document.title = `${prefixTitle} / ${store.state.title}`
            next()
          }
        },
      ]
    },
    {
      path: '/:prefix(C):itemId(\\d{4})/:id',
      component: SvgTableView,
      children: [
        {
          name: 'SvgTableView',
          path: ':at(\\d+)*',
          components: {
            table: SvgTable,
            footer: SvgTableFooter
          },
          props: {
            table: dynamicProps,
            footer: (route) => ({at: parseInt(route.params.at)})
          }
        }
      ],
      props: dynamicProps,
      beforeEnter (to, _from, next) {
        if (store.getters.item === '') {
          store.commit('SET_ITEM', to.params)
          document.title = `${prefixTitle} / ${store.state.title}`
        }
        store.commit('SET_CURRENT_CATEGORY', to.params.id)
        if (store.getters.pagesById(to.params.id) < to.params.at) {
          store.commit('SET_CURRENT_CATEGORY', '')
          next(false)
        } else {
          document.title += ` / ${store.state.categoryTitle}`
          next()
        }
      }
    },
  ],
  scrollBehavior(_to, _from, _savedPosition) {
    return {x: 0, y: 0}
  }
})

// router.beforeEach((_to, _from, next) => {
//   const queryItem = getQueryParams()['item']
//   if (queryItem && store.getters.item !== queryItem) {
//     store.commit('SET_ITEM', queryItem)
//     document.title = queryItem
//   }
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router.js